// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"520":"4e0e9000","754":"8521f2bd"}[chunkId] + ".chunk.css";
};